import { useContext } from '@nuxtjs/composition-api';
import { TrainingPlanAdvertisement } from '~/data/types/advertisement';

export const useAdvertisements = () => {
  const { $axios } = useContext();

  const getAdvertisementForTrainingPlan = async(id: number): Promise<TrainingPlanAdvertisement | null> => {
    try {
      const result = await $axios.get(`/api/advertisements/training-plan/${id}`);
      return result?.data?.data ?? null;
    } catch {
      return null;
    }
  };

  const markAdvertisementAsWatched = (id: number) => {
    try {
      $axios.put(`/api/advertisements/${id}/mark-as-watched`);
    } catch {
      // Do nothing
    }
  };

  const trackViewed = (id: number) => {
    trackInteraction('view', id, null);
  };

  const trackClicked = (id: number, secondsWatched: number) => {
    trackInteraction('click', id, secondsWatched);
  };

  const trackDismissed = (id: number, secondsWatched: number) => {
    trackInteraction('dismiss', id, secondsWatched);
  };

  const trackWatched = (id: number) => {
    trackInteraction('watch', id, null);
  };

  const trackInteraction = (type: string, id: number, secondsWatched: number | null) => {
    const params: { [key: string]: any } = {
      type,
    };

    if (secondsWatched !== null) {
      params.seconds_watched = secondsWatched;
    }

    try {
      $axios.post(`/api/advertisements/${id}/track`, params);
    } catch {
      // Do nothing
    }
  };

  return {
    getAdvertisementForTrainingPlan,
    markAdvertisementAsWatched,
    trackClicked,
    trackDismissed,
    trackViewed,
    trackWatched,
  };
};
